"use client";
/*eslint-disable */
import React, { useState, useEffect } from "react";
import MenuItem from "./MenuItem";
import { menus } from "../libs/menus";
import { Link } from "react-router-dom";
import logo_da from "../styles/images/logo_distribuidora.svg";
import icon_linkedin from "../styles/svg/linkedin.svg";
import icon_ws from "../styles/svg/Whatsapp.svg";
import icon_waze from "../styles/svg/waze.svg";
import icon_ig from "../styles/svg/instagram.svg";
import icon_facebook from "../styles/svg/facebook.svg";

const MenuLayouts: React.FC = () => {
  const [menu, setMenu] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Variable para el ancho de la ventana

  const toggleNavbar = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth); // Actualiza el ancho de la ventana en tiempo real
    };

    // Escuchar los cambios de tamaño de la ventana
    window.addEventListener("resize", handleResize);

    // Limpiar el event listener cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Solo se ejecuta una vez al montar el componente

  useEffect(() => {
    let elementId = document.getElementById("navbar");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId?.classList.add("is-sticky");
      } else {
        elementId?.classList.remove("is-sticky");
      }
    });
  });

  const classOne = menu
    ? "collapse navbar-collapse mean-menu"
    : "collapse navbar-collapse show";
  const classTwo = menu
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right";

  return (
    <>
      <div id="navbar" className="navbar-area p-fixed">
        <div className="main-nav">
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <Link to={"/"} className="navbar-brand">
                <img src={logo_da} alt="site logo" width={windowWidth > 768 ? 400 : 300} height={80} />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                  {menus.map((menuItem: any) => (
                    <MenuItem key={menuItem.label} {...menuItem} />
                  ))}
                </ul>

                <div className="others-option">
                  <a
                    href="https://www.linkedin.com/company/distribuidora-aliados-ltda/?originalSubdomain=co"
                    className="btn-style-circle crimson-light-color"
                    target="blank"
                  >
                    <img src={icon_linkedin} alt="" />
                  </a>
                  <a
                    href="https://wa.link/o69xym"
                    className="btn-style-circle crimson-light-color"
                    target="blank"
                  >
                    <img src={icon_ws} alt="" />
                  </a>
                  <a
                    href=" https://ul.waze.com/ul?place=ChIJn0htGIKbP44RqqRDEKN9Lc8&ll=4.68501140%2C-74.11815340&navigate=yes&utm_campaign=waze_website&utm_source=waze_website&utm_medium=lm_share_location"
                    className="btn-style-circle crimson-light-color"
                    target="blank"
                  >
                    <img src={icon_waze} alt="" />
                  </a>
                  <a
                    href="https://www.instagram.com/distribuidora_aliados/"
                    className="btn-style-circle crimson-light-color"
                    target="blank"
                  >
                    <img src={icon_ig} alt="" />
                  </a>
                  <a
                    href="https://www.facebook.com/DISTRIBUIDORAALIADOS/?locale=es_LA"
                    className="btn-style-circle crimson-light-color"
                    target="blank"
                  >
                    <img src={icon_facebook} alt="" />
                  </a>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuLayouts;
